// extracted by mini-css-extract-plugin
export default {"AccountFormModal":"AccountFormModal_AccountFormModal__BqmDL"};